import BaseController from './base_controller'

export default class extends BaseController {
  static targets = ['tabButton', 'tabSection', 'aerSelect', 'ratingOption', 'datepicker', 'ghgYear', 'tableTooltipContainer']

  connect() {
    this.initDatepickers()
    this.syncRatingOption()
  }

  disconnect() {
    if (this._boundHideDatepickers) {
      document.removeEventListener('focusin', this._boundHideDatepickers)
    }
    this.datepickerTargets.forEach(el => {
      if ($.data(el, 'datepicker')) $(el).datepicker('destroy')
    })
  }

  selectTab(event) {
    const button = event.currentTarget
    const tab = event.params.tab
    if (button.classList.contains('selected')) return

    this.tabButtonTargets.forEach(b => b.classList.remove('selected'))
    button.classList.add('selected')
    this.tabSectionTargets.forEach(s => s.classList.add('d-none'))
    this.tabSectionTargets.filter(s => s.classList.contains(tab)).forEach(s => s.classList.remove('d-none'))
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  syncRatingOption() {
    if (!this.hasAerSelectTarget || !this.hasRatingOptionTarget) return
    const select = this.aerSelectTarget
    this.ratingOptionTarget.value = select.options[select.selectedIndex]?.text ?? ''
  }

  showTableTooltip() {
    $(this.tableTooltipContainerTarget).fadeIn()
  }

  hideTableTooltip() {
    $(this.tableTooltipContainerTarget).fadeOut()
  }

  initDatepickers() {
    if (!this.hasDatepickerTarget || !this.hasGhgYearTarget) return

    const ghgYear = parseInt(this.ghgYearTarget.value)
    const currentYear = new Date().getFullYear()
    const defaultDate = currentYear === ghgYear ? new Date() : new Date(ghgYear, 0, 1)

    $(this.datepickerTargets).datepicker({
      dateFormat: 'dd-mm-yy',
      updateViewDate: true,
      defaultDate
    })

    this._boundHideDatepickers = this._hideDatepickers.bind(this)
    document.addEventListener('focusin', this._boundHideDatepickers)
  }

  _hideDatepickers(event) {
    if (!event.target.closest('.ui-datepicker') && !this.datepickerTargets.includes(event.target)) {
      $(this.datepickerTargets).datepicker('hide')
    }
  }
}
